export const EMPTY_METAFIELD = "EMPTY_METAFIELD";


export const INTERVAL_MONTHLY = "EVERY_30_DAYS";
export const INTERVAL_ANNUALLY = "ANNUAL";
